<template>
    <div>
        <loading loader="dots" :active.sync="isLoading" :is-full-page="true"></loading>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'FrontPage',

        components: {
            Loading
        },

        data() {
            return {
                isLoading: true
            };
        },

        created: function() {
            var params=this.$route.params;

            if (params.cluster) {
                this.$router.replace({ name: 'main', params })
            }
            else {
                this.$router.replace({ name: 'main', params: { cluster: this.$store.state.cluster } })
            }
        }
    }
</script>

<style lang="scss">
</style>
